//////////////////////////////////////////////////////////
//                                                      //   
//  PARA CLEINTES E USUÁRIOS DESLOGADOS:                //   
//                                                      //   
//  APARECE COMO ITEM UNITÁRIO DE PRODUTO               //
//  DA ABA LATERAL DIREITA DE CARRINHO                  //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR E ALTERAR                   //
//    QUANTIDADES DE UM DOS PRODUTOS NA                 //
//    ABA LATERAL DIREITA DE CARRINHO                   //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/itens_comprados.js                      //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import Loader from  '../components/loader';
import PrecoCarrinho from '../components/preco_carrinho'

import api from "../services/api";

function ProdutoCarrinho(props) {
    const {produto} = props;
    var id = produto['id']
    var img = produto[id]['img']
    var carrinho = produto[id]['carrinho']
    var estoque = produto[id]['estoque']



    async function menos(info){  // FUNÇÃO PARA DIMINUIR EM UMA UNIDADE A QUANTIDADE DE ITENS DO PRODUTO SELECIONADO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'menos'

        var carrinho_antigo = parseInt(document.getElementById(info['id']+'quantidade_numero').innerText)  // PEGA O VALOR ANTIGO
        var num_novo = carrinho_antigo - 1  // E DIMINUI UM
    
        if(num_novo === 0){  // CASO O VALOR CHEGUE A ZERO
            cancela(info)  // CANCELA O PRODUTO
        }
        else{  // CASO O VALOR NÃO SEJA ZERO
            document.getElementById(info['id']+'quantidade_numero').classList.add('d-none')  // SOME O NUMERO E APARECE O LOADER
            document.getElementById(info['id']+'loader').classList.remove('d-none')

            var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}  // CRIA O DICIONÁRIO PARA ALTERAR O VALOR NO DB
            dict_itens['comprar'] = info['id']
            dict_itens['quantidade'] = num_novo

            info[info['id']]['carrinho'] = num_novo  


            var list_itens = sessionStorage['comprar'].split(';')  // REMOVE O VALOR ANTERIOR DA SESSÃO
            list_itens.forEach(function (element, index){
                var item = JSON.parse(element)
                if(item['id'] == info['id']){
                    list_itens.splice(index, 1)
                }
            })   

            if(list_itens){  // E ADICIONA O VALOR NOVO NA SESSÃO (SEPARADOS POR ;)
                if(list_itens.length > 0){
                    var lista_prod = list_itens.join(';') 
                    sessionStorage['comprar'] = lista_prod + ';' + JSON.stringify(info)           
                }
                else{
                    sessionStorage['comprar'] = JSON.stringify(info)           
                }                 
            }
            else{
                sessionStorage['comprar'] = JSON.stringify(info)           
            }   
            
            if(sessionStorage['login']){  // CASO O USUÁRIO ESTIVER LOGADO COMO CLIENTE
                if(!sessionStorage['login'].includes('/')){
                    var produtos = await api.post('add_session_db',{  // ADICIONA ISSO NO DB
                        dict_itens
                    }).then((response) => {
                        return response
                    })   
                    // 'produtos' NÃO RETORNA NADA 
                }
            }   
            
            
            var id = produto['id']  // SOME LOADER E APARECE NUMERO NOVO
            produto[id]['carrinho'] = num_novo         
            document.getElementById(info['id']+'quantidade_numero').innerText = num_novo
            try{
                document.getElementById(info['id']+'input').children[0].value = num_novo
            }
            catch{
                console.log('item ainda não foi renderizado na home')
            }
            document.getElementById(info['id']+'quantidade_numero').classList.remove('d-none')
            document.getElementById(info['id']+'loader').classList.add('d-none')        
        }

    } 
    
    
    async function mais(info){  // FUNÇÃO PARA AUMENTAR EM UMA UNIDADE A QUANTIDADE DE ITENS DO PRODUTO SELECIONADO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'mais'

        var carrinho_antigo = parseInt(document.getElementById(info['id']+'quantidade_numero').innerText)  // PEGA O VALOR ANTIGO
        var num_novo = carrinho_antigo + 1  // E AUMENTA EM UM

        if (estoque !== carrinho_antigo){  // NÃO ADICIONA CASO O VALOR NOVO SEJA MAIOR DO QUE A QUANTIDADE DE PRODUTOS EM ESTOQUE
            document.getElementById(info['id']+'quantidade_numero').classList.add('d-none')  // SOME NÚMERO E APARECE LOADER
            document.getElementById(info['id']+'loader').classList.remove('d-none')           

            var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}  // CRIA DICIONÁRIO PARA ALTERAR O VALOR NO DB
            dict_itens['comprar'] = info['id']
            dict_itens['quantidade'] = num_novo
            info[info['id']]['carrinho'] = num_novo
            
            var list_itens = sessionStorage['comprar'].split(';')  // REMOVE O VALOR ANTERIOR DA SESSÃO
            list_itens.forEach(function (element, index){
                var item = JSON.parse(element)
                if(item['id'] == info['id']){
                    list_itens.splice(index, 1)
                }
            })   

            if(list_itens){  // E ADICIONA O VALOR NOVO NA SESSÃO (SEPARADOS POR ;)
                if(list_itens.length > 0){
                    var lista_prod = list_itens.join(';') 
                    sessionStorage['comprar'] = lista_prod + ';' + JSON.stringify(info)           
                }
                else{
                    sessionStorage['comprar'] = JSON.stringify(info)           
                }                 
            }
            else{
                sessionStorage['comprar'] = JSON.stringify(info)           
            }   
            
            if(sessionStorage['login']){  // CASO O USUÁRIO ESTIVER LOGADO COMO CLIENTE
                if(!sessionStorage['login'].includes('/')){  
                    var produtos = await api.post('add_session_db',{  // ADICIONA ISSO NO DB   
                        dict_itens
                    }).then((response) => {
                        return response
                    })    
                    // 'produtos' NÃO RETORNA NADA
                }
            } 
              
              var id = produto['id']  // SOME LOADER E APARECE NUMERO NOVO
              produto[id]['carrinho'] = num_novo                  
              document.getElementById(info['id']+'quantidade_numero').innerText = num_novo
              try{
                document.getElementById(info['id']+'input').children[0].value = num_novo
              }
              catch{
                  console.log('item ainda não foi renderizado na home')
              }
              document.getElementById(info['id']+'quantidade_numero').classList.remove('d-none')
              document.getElementById(info['id']+'loader').classList.add('d-none')  
        }

    } 
    
    async function cancela(input){  // FUNÇÃO PARA PEDIR CONFIRMAÇÃO DO CANCELAMENTO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'cancel_carrinho'
        // FUNÇÃO CHAMADA QUANDO O VALOR DE 'quantidade_numero' CHEGA A ZERO A PARTIR DOS CLICKS NO BOTÃO 'menos'

        document.getElementById(input['id'] + 'quantidade').classList.add('d-none')  // SOME A QUANTIDADE  DE ITENS E OS BOTÕES DE MAIS E MENOS
        document.getElementById(input['id'] + 'cancelar').classList.remove('d-none')  // APARECE AS OPÇÕES DE CONFIRMAÇÃO PARA O CANCELAMENTO
        document.getElementById(input['id'] + 'cancel_carrinho').classList.add('d-none')
    }
    
    async function cancela_nao(input){  // FUNÇÃO CASO O USUÁRIO DESISTA DO CANCELAMENTO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'cancela_nao'
        
        document.getElementById(input['id'] + 'quantidade').classList.remove('d-none')  // SOME AS OPÇÕES DE CONFIRMAÇÃO PARA O CANCELAMENTO
        document.getElementById(input['id'] + 'cancelar').classList.add('d-none')  // APARECE A QUANTIDADE DE ITENS E OS BOTÕES DE MAIS E MENOS
        document.getElementById(input['id'] + 'cancel_carrinho').classList.remove('d-none')
    }
    
    async function cancela_sim(info){  // FUNÇÃO CASO O USUÁRIO CONFIRME O CANCELAMENTO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'cancela_sim'

        var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}  // CRIA O DICIONÁRIO PARA SALVAR OS DADOS NO DB
        dict_itens['comprar'] = info['id']
        dict_itens['quantidade'] = 0

        
        var list_itens = sessionStorage['comprar'].split(';')  // RREMOVE O ITEM DA SESSÃO
        list_itens.forEach(function (element, index){
            var item = JSON.parse(element)
            if(item['id'] == info['id']){
                list_itens.splice(index, 1)
            }
        })   
        var lista_prod = list_itens.join(';') 
        sessionStorage['comprar'] = lista_prod
        
        if(sessionStorage['login']){  // CASO O USUÁRIO ESTIVER LOGADO COMO CLIENTE
            if(!sessionStorage['login'].includes('/')){  // SALVA ISSO NO DB     
                var produtos = await api.post('add_session_db',{
                    dict_itens
                }).then((response) => {
                    return response
                })    
                // 'produtos' NÃO RETORNA NADA    
            }
        } 

        
        document.getElementById(info['id'] + 'quantidade').classList.remove('d-none')  // SOME DA TELA O ITEM DO PRODUTO
        document.getElementById(info['id'] + 'cancelar').classList.add('d-none')
        document.getElementById(info['id'] + 'produto_carrinho').classList.add('d-none')
        document.getElementById(info['id'] + 'cancel_carrinho').classList.remove('d-none')
        produto[id]['carrinho'] = 0
        
        
        try{
            document.getElementById(info['id'] + 'carrinho').classList.remove('d-none')  // PODE SER QUE ELE JÁ TENHA SUMIDO PELA SESSION
            document.getElementById(info['id'] + 'input').children[0].value = "0"
            document.getElementById(info['id'] + 'input').classList.add('d-none')
        }
        catch{
            console.log('erro')
        }
            
        
        var inicio = props.callback()  // CHAMA A FUNÇÃO DE REFAZER O CARRINHO
        document.getElementById(info['id'] + 'produto_carrinho').classList.remove('d-none')  // E RETIRA A CLASSE 'd-none' PARA CASO O USUÁRIO ADICIONE 
                                                                                                // O PRODUTO E NOVAMENTE NO CARRINHO
    }

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'Loader' -> APARECE ENQUANTO OS PRODUTOS NÃO SÃO CARREGADOS
      // 'PrecoCarrinho' -> PREÇO TOTAL DO PEDIDO

    return (
        <div className="row col col-12 pr-0 pl-3 mx-0 item-carrinho hover-borda-verde" id={produto['id'] + 'produto_carrinho'}>
            <div className="col-6">
                <button id={produto['id'] + 'cancel_carrinho'} className="btn-verde-pqn my-5" onClick={() => cancela(produto)}><i className="fa fa-close"></i></button>
                <img className='picture_carrinho ml-3 my-3' src={img} alt="Avatar"></img>
            </div>

            <div className="col-6 my-4" id={produto['id'] + 'quantidade'}>
                <div className="d-flex justify-content-between px-0 container mb-2">
                    <div>
                        <button className="cancel-pqn" id={produto['id'] + 'menos'} onClick={() => menos(produto)}>
                            <i className="fa fa-minus"></i>
                        </button>
                    </div>
                        <div>
                            <div className="verde montserrat font-x-large h-100 h-100 loader-item-carrinho d-none" id={produto['id'] + 'loader'}>
                                <Loader />
                            </div>
                            <div className="verde montserrat font-x-large h-100 h-100" id={produto['id'] + 'quantidade_numero'}>{carrinho}</div>
                        </div>

                        <div>
                        <button className="btn-verde-pqn" id={produto['id'] + 'mais'} onClick={() => mais(produto)}>
                            <i className="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <PrecoCarrinho props={props.produto}/>
            </div>

            <div id={produto['id'] + "cancelar"} className="d-none col-6 row px-0">
                <p className="mb-0 py-3 my-4 montserrat col-6 px-0">Cancelar Produto?</p>

                <div className='col-6 px-0 py-5'>
                <button className="btn-verde-pqn px-0" id={produto['id'] + 'cancela_sim'} onClick={() => cancela_sim(produto)}>
                            <i className="fa fa-check"></i>
                </button>                    
                <button className="cancel-pqn px-0 pull-right" id={produto['id'] + 'cancela_nao'} onClick={() => cancela_nao(produto)}>
                            <i className="fa fa-close"></i>
                </button>
                </div>
            </div>
        </div>                    
    );
}


export default ProdutoCarrinho;
  